import { HashLink as Link } from "react-router-hash-link";

const Team = () => {
  return (
    <section className="team-section" id="team">
      <div className="title-team">
        <h3>Notre Équipe</h3>
        <h2>DES AVOCATS EXPÉRIMENTÉS EN DROIT BANCAIRE</h2>
        <p>
          Le cabinet LexiCredis est animé par une équipe en d'avocats expert en
          droit
          <br />
          bancaire, dédiés à la défense des intérêts de leurs clients.
        </p>
      </div>
      <article className="team-content">
        <div className="team-card first">
          <article>
            <h3 className="text-blue">
              Maître Hervé Gerbi & Maître Laurent Gerbi
            </h3>
            <h4>Barreau de Nice - Droit bancaire - Défense des banques</h4>
            <Link to="/#contact" className="text-blue">
              Contacter <i class="fa-solid fa-chevron-right fa-sm"></i>
            </Link>
          </article>
        </div>
        <div className="team-card second">
          <article>
            <h3 className="text-blue">
              Maître Patrick Gerbi, Avocat honoraire
            </h3>
            <h4>
              Plus de 50 ans d'expérience - Vision stratégique - Expertise
              reconnue
            </h4>
            <Link to="#contact" className="text-blue">
              Contacter <i class="fa-solid fa-chevron-right fa-sm"></i>
            </Link>
          </article>
        </div>
      </article>
    </section>
  );
};

export default Team;